<template>
    <v-card color="#F4FEFB">
        <v-card-title>
            入力欄の設定
        </v-card-title>
        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-select
                :items="selectDestinations"
                label="入力者"
                outlined
                hide-details
                v-on:change="changeUserId"
                v-model="selected"
                background-color="white"
              >
              </v-select>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-text-field
                v-model="label"
                label="ラベル"
                outlined
                hide-details
                v-on:blur="changeLabel"
                background-color="white"
              >
              </v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-list>
    </v-card>
</template>

<script>
export default {
    props: ['destinations', 'destinationId', 'currentLabel'],
    data: function () {
        return {
            selectDestinations: [],
            label: "",
            selected: 0,
        }
    },
    created: function () {
        this.selected = this.destinationId;
        this.label = this.currentLabel?? '';
        Object.entries(this.destinations).forEach((val, index) => {
            this.selectDestinations.push({
                text: val[1].destination_user_name,
                value: val[1].id
            })
        })
    },
    methods: {
      changeUserId: function (e) {
        this.$emit('changeUserId', e)
      },
      changeLabel: function (e) {
        this.$emit('changeLabel', e.target.value)
      }
    }
}
</script>

<style scoped>

</style>